/**
 * 主布局组件
 * 组合顶栏(Header)、侧边栏(Sidebar)和内容区，支持侧边栏折叠
 */
import { useState } from 'react';
import { Sidebar } from './sidebar';
import { Header } from './header';

interface LayoutProps {
  children: React.ReactNode;
}

/** 主布局组件：组合顶栏、侧边栏和内容区，管理侧边栏折叠状态 */
export function Layout({ children }: LayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <div className="h-screen overflow-hidden bg-surface-950 text-surface-200">
      <div className="flex h-full">
        <Sidebar
          collapsed={sidebarCollapsed}
          mobileOpen={mobileSidebarOpen}
          onCloseMobile={() => setMobileSidebarOpen(false)}
        />
        <div className="flex min-w-0 flex-1 flex-col">
          <Header
            sidebarCollapsed={sidebarCollapsed}
            onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)}
            onOpenMobileNav={() => setMobileSidebarOpen(true)}
          />
          <main className="flex-1 overflow-y-auto bg-surface-950">
            <div className="mx-auto w-full max-w-[1680px] p-4 sm:p-5 lg:p-6 xl:p-8">
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
